import TransactionDetails from './transaction-details.vue'
export default TransactionDetails
